import { useRouter } from "next/router";

const StyledText = ({ children }: React.PropsWithChildren) => (
  <div className={"not-italic font-medium text-xl leading-6 text-center text-gray-800"}>{children}</div>
);

export default function Four04() {
  const router = useRouter();

  return (
    <div className={"container h-screen"}>
      <div className={"flex flex-col h-full items-center justify-center"}>
        <StyledText>Oh no... Sorry!</StyledText>
        <StyledText>We couldn’t find this page.</StyledText>

        <button type={"button"} className={"btn-pill bg-pink-happyway m-2"} onClick={() => router.back()}>
          Go back
        </button>
      </div>
    </div>
  );
}
